function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "policies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 1093",
    d: "M184.361 69.186a.379.379 0 0 0-.4-.35 11.47 11.47 0 0 1-7.3-2.338.4.4 0 0 0-.5 0 11.471 11.471 0 0 1-7.3 2.338.379.379 0 0 0-.4.35c-.15 3.713-.066 8.421 1.623 10.633a17.923 17.923 0 0 0 6.326 4.59 18.016 18.016 0 0 0 6.326-4.59c1.689-2.212 1.773-6.92 1.623-10.633zm-4.549 4.376-3.924 4.122a.606.606 0 0 1-.42.181h-.008a.584.584 0 0 1-.412-.17l-2.024-1.976a.537.537 0 0 1 .01-.784.6.6 0 0 1 .819.009l1.592 1.56 3.512-3.687a.6.6 0 0 1 .814-.033.537.537 0 0 1 .042.778z",
    transform: "translate(-164.412 -63.41)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/policies.0de8ebd655de9c6a510e67af0d72f78f.svg";
export { ForwardRef as ReactComponent };